import React from 'react'

import { data } from './data'

import styles from './styles.module.scss'

export const View = () => {
	return (
		<article className={styles.tab}>
			<h2 className={styles.heading}>{data.heading}</h2>
			<p className={`${styles.content} ${styles.largeMargin}`}>{data.content}</p>

			<div className={styles.cardGreen}>
				<p className={styles.cardHeading}>{data.card.heading}</p>
				{data.card.content.map((el) => (
					<p className={styles.content} key={el}>
						{el}
					</p>
				))}
				<a
					className={styles.link}
					href={data.card.link.href}
					target='_blank'
					rel='noopener noreferrer nofollow'
				>
					{data.card.link.content}
				</a>
			</div>

			<div className={styles.card}>
				<p>
					В этом же году{' '}
					<a
						className={styles.link}
						href='https://navigator.sk.ru/orn/1123861'
						target='_blank'
						rel='noopener noreferrer nofollow'
					>
						стали участниками инновационного центра «Сколково»
					</a>
					, подтвердив свою технологичность.
				</p>
			</div>

			<div className={styles.card}>
				<p>
					А также подтвердили свою надёжность — мы прошли проверку Банком России:
					<a
						className={styles.link}
						href='https://www.cbr.ru/finorg/foinfo/?ogrn=1196658084743'
						target='_blank'
						rel='noopener noreferrer nofollow'
					>
						{' '}
						компания из группы Credit.Club вступила в реестр операторов инвестиционных платформ.
					</a>
				</p>
			</div>
		</article>
	)
}
